import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Actualizat:',
  breadcrumbs: {
    home: 'Pagina de pornire',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'De ce puteți avea încredere în noi',
        details: {
          text: '<h2>De ce puteți avea încredere în noi</h2><p>Articolele de pe Natu.Care sunt scrise pe baza cercetărilor științifice, a datelor de pe site-urile guvernamentale și a altor surse de încredere. Textele sunt scrise în colaborare cu medici, nutriționiști și alți experți în sănătate și frumusețe. Articolele sunt revizuite înainte de publicare și în timpul actualizărilor semnificative.</p>',
          footerText: '<p>Aflați mai multe despre <a href="/ro/despre-noi/proces-editorial">procesul nostru editorial</a></p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informații privind publicitatea',
        details: {
          text: '<h2>Informații despre publicitate</h2><p>Contenutul de pe Natu.Care poate conține linkuri către produse din vânzarea cărora putem primi un comision. Atunci când creăm conținut, aderăm la standarde editoriale ridicate și avem grijă să fim obiectivi cu privire la produsele discutate. Prezența linkurilor afiliate nu este dictată de partenerii noștri, iar noi înșine selectăm în mod complet independent produsele pe care le analizăm.</p>',
          footerText: '<p>Aflați mai multe în <a href="/ro/regulament">regulament</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Verificat de un expert',
      footerText: '<p>Aflați mai multe despre <a href="/ro/despre-noi/proces-editorial">procesul nostru editorial</a></p>'
    }
  },

  mediabar: {
    heading: 'Presa despre noi:',
    href: '/ro/despre-noi',
    title: 'Despre noi',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Asigurați un corp sănătos',
    description: 'Încercați suplimentele de înaltă calitate de la Natu.Care',
    button: {label: 'Vezi produsele', href: 'https://natu.shop/collections'},
    picture: {alt: 'Femei tinere, frumoase, cu piele în stare bună.'}
  },

  authorship: {
    heading: 'Editorial',
    link: {
      label: 'Faceți cunoștință cu echipa',
      href: '/ro/despre-noi/redactie'
    }
  },

  similarArticles: {
    headingBlogList: 'Artykuły',
    headingBlogPost: 'Podobne artykuły'
  }
};